import React from 'react'

//Final Form
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

//Material-UI
import Grid from '@material-ui/core/Grid'

import Dialog from '../../../../../control/dialog/dialog'
import TextField from '../../../../../control/textfield/textfield'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import PageAction from '../pageAction'
import MyAccordion from '../../../../../control/accordion/accordion'

import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import useTranslate from '../../../../../i18n/useTranslate'

import DocumentTestResult from '../../../shareUI/documentTestResult/documentTestResult'
import useVerifyDocumentSubmittedWithdraw from './useVerifyDocumentSubmittedWithdraw'
import useCheckPermission from '../../../../../utilities/checkPermission'
import UploadAdditionalDoc from '../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'

type VerifyDocSubmittedWithdrawViewProps = ReturnType<typeof useVerifyDocumentSubmittedWithdraw> &
    VerifyDocSubmittedWithdraw
const VerifySubmittedWithdrawView: React.FC<VerifyDocSubmittedWithdrawViewProps> = (props) => {
    const {
        initialVal,
        initialUploadFile,
        uploadDocumentTopic,
        isViewMode,
        configDialog,
        onRefForm,
        onClickCancel,
        onSubmit,
        onRefDialog,
        onDirtyChange,
        projectData,
        confirmEditDocResult,
        handleEditDocResult,
    } = props
    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()
    const checkPermission = useCheckPermission()
    const canOfficerEdit = checkPermission.isAllowOfficerToEdit(projectData)
    const isDisabledTestResult = canOfficerEdit ? false : true
    const canOfficerSaveDraft = checkPermission.checkSaveDraft()

    return (
        <Form
            onSubmit={onSubmit}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={initialVal}
            keepDirtyOnReinitialize={true}
        >
            {(formProps) => {
                onRefForm?.(formProps)
                return (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <MyAccordion title={translate.get('LABEL.WITHDRAW_REASON')}>
                                <TextField
                                    name="withdrawCause"
                                    materialInputProps={{
                                        label: translate.get('LABEL.REASON'),
                                        disabled: true,
                                        multiline: true,
                                        rows: 5,
                                    }}
                                    maxLength={1000}
                                    resetButtom
                                />
                            </MyAccordion>
                        </Grid>
                        <Grid item xs={12}>
                            <UploadDoc
                                initialData={initialUploadFile}
                                documentTitleList={uploadDocumentTopic}
                                isViewMode={true}
                                latestDocument={undefined}
                                isUseUploadfileEdit={false}
                                zipDownload={true}
                                isRequire={false}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <UploadAdditionalDoc isViewMode={true} isEditable={checkPermission.isUserAdmin()} />
                        </Grid>

                        <Grid item xs={12}>
                            <DocumentTestResult
                                onChangeDocCompletely={(val: any) => {
                                    const isCompletely = val === '1' ? true : false
                                    formProps.form.change('isCompletely', isCompletely)
                                }}
                                isViewMode={isViewMode}
                                useAccordionMode={isDisabledTestResult}
                                onSubmitEdit={async () => {
                                    await confirmEditDocResult(formProps, [
                                        'isCompletelyDoc',
                                        'resubmitDocDate',
                                        'remark',
                                        'remarkWithFormat',
                                    ])
                                }}
                                onClickModeEdit={() => handleEditDocResult(formProps)}
                            />
                        </Grid>
                        {!isViewMode && (
                            <Grid item xs={12}>
                                <PageAction
                                    onClickClose={() => {
                                        onClickCancel(formProps.dirty)
                                    }}
                                    onClickSave={() => {
                                        formProps.form.change('saveType', 'SAVE')
                                        formProps.handleSubmit()
                                        formProps.invalid &&
                                            formProps.errors &&
                                            snackbarAction.openSnackbar({
                                                message: translate.get('MESSAGE.M012'),
                                                type: 'error',
                                            })
                                    }}
                                    onClickSaveDraft={
                                        canOfficerSaveDraft
                                            ? () => {
                                                  formProps.form.change('saveType', 'DRAFT')
                                                  formProps.handleSubmit()
                                              }
                                            : undefined
                                    }
                                />
                            </Grid>
                        )}

                        <Dialog onRef={onRefDialog} {...configDialog} />
                        <FormSpy subscription={{ dirty: true }} onChange={onDirtyChange} />
                    </Grid>
                )
            }}
        </Form>
    )
}

export type VerifyDocSubmittedWithdraw = {
    onSaveComplete?: (status: number, isDraft: boolean) => void
}
const VerifyDocumentProjectWithdraw: React.FC<VerifyDocSubmittedWithdraw> = (props) => {
    const model = useVerifyDocumentSubmittedWithdraw(props)
    return <VerifySubmittedWithdrawView {...model} {...props} />
}

export default VerifyDocumentProjectWithdraw
